import React, { useRef } from 'react';
import {
    Button, Modal, ModalBody, ModalHeader, ModalFooter
} from 'reactstrap';
import { Formik, Form, ErrorMessage, Field } from "formik";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { isFileExtValid } from '../../helpers/common';

function MultipleLORFilesUploadModal({ handleClose, upload, isModalOpen, lorDetails, isLoading, title, fileType }) {
    const fileRef = useRef([]);

    const initialValues = {
        files: [
            {
                file: null
            }
        ],
        lorDescription: lorDetails?.lorDescription || "",
        lorRequiredId: lorDetails?.lorRequiredId || 0
    };

    // Validation Schema
    const validationSchema = Yup.object().shape({
        files: Yup.array()
            .of(
                Yup.object().shape({
                    file: Yup.mixed()
                        .required("File is required"),
                })
            ),
        // lorDescription: Yup.string()
        //     .required("Description is required")
        //     .min(3, "Description must be at least 3 characters long"),
    });

    // On Submit
    const onSubmit = (values) => {
        upload(values);
    };

    // Add New File-Description Pair
    const addFileField = (setFieldValue, values) => {
        const newFiles = [...values.files, { file: null }];
        setFieldValue("files", newFiles);
    };

    const uploadFiles = async (file, setFieldValue, index) => {
        fileRef.current.push(React.createRef());
        const fileName = file?.name;
        const fileSize = file?.size;
        const fileExt = file?.type;

        if (file && fileName && fileSize) {
            const maxFileSize = process.env.REACT_APP_FILE_SIZE * Math.pow(10, 6);
            if (fileSize > maxFileSize) {
                clearFileInput(index, setFieldValue)
                toast.error(`File size should not be more than ${process.env.REACT_APP_FILE_SIZE} MB`)
            } else if (!isFileExtValid(fileExt, fileName)) {
                toast.error('Invalid file name or multiple extensions detected')
            }
            else {
                setFieldValue(
                    `files[${index}].file`, file);
            }

        }
        else {
            clearFileInput(index, setFieldValue)
        }
    }

    const clearFileInput = (index, setFieldValue) => {
        setFieldValue(`files[${index}].file`, null)
        const input = fileRef.current[index]?.current;
        if (input) {
            input.value = "";
        }
    }

    // Remove File-Description Pair
    const removeFileField = (index, setFieldValue, values) => {
        let newFiles = [];
        if (values.files[index].id)
            newFiles = values.files.map((file, i) => i === index ? { ...file, isDeleted: true } : file);
        else
            newFiles = values.files.filter((_, i) => i !== index);
        setFieldValue("files", newFiles);
    };

    return (
        <Modal isOpen={isModalOpen} toggle={() => handleClose()} size='lg'>
            <ModalHeader toggle={() => handleClose()}>{title}</ModalHeader>
            <ModalBody>
                <div className="mb-3">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({ values, setFieldValue, errors, touched, setFieldTouched, dirty }) => (
                            <Form>
                                {values.files.map((fileObj, index) => (
                                    !fileObj.isDeleted && <div key={index} className="d-flex mb-2">
                                        <div className='me-3' style={{ width: "100%" }}>
                                            <label htmlFor={`files[${index}].file`}>File</label>
                                            <input
                                                type="file"
                                                id={`files[${index}].file`}
                                                name={`files[${index}].file`}
                                                className={`form-control file-input ${touched?.files?.length > 0 && touched.files[index]?.file && errors?.files?.length > 0 && errors?.files[index]?.file ? 'is-invalid' : ''}`}
                                                onChange={(event) => {
                                                    uploadFiles(event.currentTarget.files[0], setFieldValue, index);
                                                }}
                                                onBlur={() => setFieldTouched(`files[${index}].file`, true)}
                                                ref={fileRef[index]}
                                            />
                                            <ErrorMessage
                                                name={`files[${index}].file`}
                                                component="div"
                                                style={{ color: "red" }}
                                            />
                                        </div>

                                        {index !== 0 && <Button
                                            type="button"
                                            color="link"
                                            className="fw-normal text-danger p-0"
                                            onClick={() => removeFileField(index, setFieldValue, values)}
                                            style={{ width: "5%" }}
                                        >
                                            <i className="bx bx-trash" style={{ width: '24px' }}></i>
                                        </Button>}
                                    </div>
                                ))}
                                {fileType !== 'destruction_certificate' && fileType !== 'final_police_report' && <Button
                                    type="button"
                                    color="link mt-2"
                                    style={{ textDecoration: 'none' }}
                                    className="text-success p-0 mb-3"
                                    onClick={() => addFileField(setFieldValue, values)}

                                >
                                    <span>Add More +</span>
                                </Button>}
                                <div className='mb-3'>
                                    <label htmlFor='lorDescription'>Description</label>
                                    <Field
                                        id='lorDescription'
                                        name='lorDescription'
                                        className={`form-control file-input ${touched?.lorDescription > 0 && errors?.lorDescription ? 'is-invalid' : ''}`}
                                        placeholder='Enter Description'
                                        value={values.lorDescription}
                                        onChange={(e) => setFieldValue('lorDescription', e.target.value)}
                                    />
                                    <ErrorMessage
                                        name="lorDescription"
                                        component="div"
                                        style={{ color: "red" }}
                                    />
                                </div>
                                <ModalFooter className='d-flex justify-content-between'>
                                    <Button color="primary" type="submit" className="ITC_Blue_color" disabled={!dirty || isLoading}>
                                        Submit
                                    </Button>
                                </ModalFooter>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ModalBody>
        </Modal >
    );

}

export default MultipleLORFilesUploadModal;